"use client";

import { MobileMenuProvider } from "@lib/context/mobile-menu-context";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useRouter } from "next/router";
import { useMemo } from "react";

export default function Providers({ children }: { children: React.ReactNode }) {
  const { locale } = useRouter();
  const theme = useMemo(
    () =>
      createTheme({
        direction: locale === "ar" ? "rtl" : "ltr",
        typography: {
          fontFamily:
            locale === "ar"
              ? '"GE SS Two", "Massilia", Arial, sans-serif'
              : '"Massilia", Arial, sans-serif',
        },
      }),
    [locale]
  );

  return (
    <ThemeProvider theme={theme}>
      <MobileMenuProvider>{children}</MobileMenuProvider>
    </ThemeProvider>
  );
}
